import {DATE_PIPE_DEFAULT_OPTIONS} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ApplicationConfig, importProvidersFrom, InjectionToken, isDevMode} from '@angular/core';
import {MAT_LUXON_DATE_ADAPTER_OPTIONS, MatLuxonDateModule} from '@angular/material-luxon-adapter';
import {MAT_DATE_FORMATS} from '@angular/material/core';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {provideAnimations} from '@angular/platform-browser/animations';
import {
    InMemoryScrollingFeature,
    InMemoryScrollingOptions,
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
} from '@angular/router';
import {DEFUALT_DATE_FORMAT} from '@evencel/models';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {NgxsStoragePluginModule} from '@ngxs/storage-plugin';
import {NgxsModule} from '@ngxs/store';
import {NgxsResetPluginModule} from 'ngxs-reset-plugin';
import {environment} from '../environments/environment';
import {IEnvironmentModel} from '../environments/environment.model';
import {appRoutes} from './app.routes';
import {ApiInterceptor} from './services/_interceptors';
import {TokenInterceptor} from './services/_interceptors/token-interceptor.service';
import {AppState} from './states';

export const APP_CONFIG = new InjectionToken<IEnvironmentModel>('Application config');

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const MY_FORMATS = {
    parse: {
        dateInput: DEFUALT_DATE_FORMAT,
    },
    display: {
        dateInput: DEFUALT_DATE_FORMAT,
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, inMemoryScrollingFeature, withComponentInputBinding()),
        provideAnimations(),

        importProvidersFrom(HttpClientModule),
        importProvidersFrom(MatLuxonDateModule),
        // NGXS
        importProvidersFrom(NgxsModule.forRoot([AppState], {developmentMode: isDevMode()})),
        importProvidersFrom(NgxsRouterPluginModule.forRoot()),
        importProvidersFrom(NgxsStoragePluginModule.forRoot({key: ['app', 'admin']})),
        importProvidersFrom(NgxsResetPluginModule.forRoot()),

        {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
        {provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
        {provide: APP_CONFIG, useValue: environment},
        {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: environment.snackbarDuration}},
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: {dateFormat: DEFUALT_DATE_FORMAT, timezone: 'UTC'},
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS,
        },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {panelClass: 'mat-dialog-right'},
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {appearance: 'outline', subscriptSizing: 'dynamic'},
        },
    ],
};
